<div class="horizontal-center">
  <div class="centered-element" id="mobileSignatureBox"></div>
</div>
